import { FormDialog } from 'components/dialog/form'
import { SearchsConventionResult, useEditSearchsConvention } from 'interface/search/convention'
import { useSearchsConventionForm, SearchsConventionForm } from '../form'

type EditSearchsConventionDialogProps = {
  searchId: number
  convention: SearchsConventionResult
  onSubmit: (result: SearchsConventionResult) => void
  onClose: () => void
}
export const EditSearchsConventionDialog = ({
  searchId,
  convention,
  onSubmit,
  onClose
}: EditSearchsConventionDialogProps) => {
  const [postState, submit] = useEditSearchsConvention(searchId, convention.searchsConventionId, { onEditted: onSubmit })
  const form = useSearchsConventionForm({ searchId, data: convention, onSubmit: submit })
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title={convention.conventionName ?? ''}
      isLoading={postState.posting}
      error={postState.error}
      body={<SearchsConventionForm {...form}/>}
      submitLabel="確定"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}
